// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "index." + {"12":"20ed279f4adc750f7c57","777":"6888cfe60b8e38e95c1a"}[chunkId] + ".js";
};